export default __webpack_public_path__ + "static/media/Performance_Mobile@2x.41f92377.png";